import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  get(name: string) {
    return localStorage.getItem(name);
  }

  set(name: string, value: any) {
    return localStorage.setItem(name, value);
  }

  getAll() {
    return JSON.stringify(localStorage);
  }

  delete(name: string) {
    localStorage.removeItem(name);
  }
}
